var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},[_c('h4',[_vm._v(_vm._s(_vm.decodeHTMLEntities(_vm.text)))]),_vm._v(" "),(_vm.length != 0)?_c('h4',[_vm._v(_vm._s(_vm.length))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }